export enum UserType {
	UNWANTED = 'unwanted',
	PENDING = 'pending',
	ALPHA = 'alpha',
}
